<template>
  <div v-if="$root.tasks" class="flex mb5">
    <div class="w-100">
      <Tracking/>
      <div class="flex flex-row-ns flex-column">
        <div id="sidebar" class="w-20 pr3 b">
          <h3 class="mv3 f3">Tags</h3>
          <div @click="$root.tag = ''" class="ttu pointer grow pv2">
            <span class="bg-nord4 pv1 ph2 dib br2" :class="{'bg-nord7': $root.tag == ''}">All</span>
          </div>
          <div @click="$root.tag = tag" class="pointer grow pv2" v-for="tag in $root.tasks.getTags()" :key="tag">
            <span class="bg-nord4 pv1 dib ph2 br2" :class="{'bg-nord7': $root.tag == tag}">#{{tag}}</span>
          </div>
        </div>
        <Task class="w-100" isroot v-model="$root.tasks"/>
      </div>
      <UpdateTime/>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
}
</script>
<style>
.v-tour__target--highlighted {
  border: 3px solid #81A1C1;
  box-shadow: none;
}
</style>
